export function isStreamingJsonResult(content: string): boolean {
  const trimmed = content.trim();
  return !trimmed || (trimmed.startsWith("{") && !trimmed.endsWith("}"));
}
